import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CmsItem, TransformEmailHtmlHelper } from '@coin/shared/cms/util';
import { V2ButtonComponent, V2DialogModule } from '@coin/shared/core/ui-storybook';
import { PureFunctionPipe } from '@coin/shared/core/util-pipes';
import { TranslateModule } from '@ngx-translate/core';

interface SelectionItem {
  contentHtml: SafeHtml;
  id: string;
  type: string;
}

@Component({
  selector: 'coin-email-index-list-selection',
  templateUrl: './email-index-list-selection.component.html',
  styleUrls: ['./email-index-list-selection.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [V2DialogModule, TranslateModule, PureFunctionPipe, V2ButtonComponent]
})
export class EmailIndexListSelectionComponent implements OnInit {
  data = inject<{
    content: CmsItem[];
    selectedItemReferenceIds: string[];
  }>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<EmailIndexListSelectionComponent>>(MatDialogRef);
  private readonly domSanitizer = inject(DomSanitizer);

  public selectionItems: SelectionItem[] = [];
  public selectedItem: SelectionItem;

  // pure  function
  public isSelected(id: string, selectedItemReferenceIds: string[]): boolean {
    return selectedItemReferenceIds?.includes(id);
  }

  ngOnInit(): void {
    this.setupSelectionItems();
  }

  private setupSelectionItems(): void {
    if (!this.data?.content?.length) {
      return;
    }
    for (const contentItem of this.data.content) {
      let replaceTableCellHTML = TransformEmailHtmlHelper.getEmailHtmlForContentItem(contentItem);
      replaceTableCellHTML = replaceTableCellHTML
        .replaceAll(
          '<td style="width: 25px; vertical-align: text-top; border-top: 15px solid transparent;">',
          '<td style="width: 25px; vertical-align: text-top; border-top: 0px solid transparent;">'
        )
        .replaceAll(/&nbsp;(?!<)|(?<!>)&nbsp;/g, ' ');
      this.selectionItems.push({
        id: contentItem.id,
        type: contentItem.type,
        contentHtml: this.domSanitizer.bypassSecurityTrustHtml(replaceTableCellHTML)
      });
    }
  }

  public proceed(): void {
    this.dialogRef.close(this.selectedItem);
  }

  public close(): void {
    this.dialogRef.close();
  }
}
